@if (form.view) {
    @if (form.view) {
        <form #formRef="ngForm" (ngSubmit)="submit()" @fadeInOut>
            <sf-form name="form" [view]="form.view" [(ngModel)]="form.model" (ngModelChange)="modelChange.emit($event)"></sf-form>
        </form>
    }
} @else {
    @if (form.error) {
        <ngxh6-api-error [error]="form.error"></ngxh6-api-error>
    } @else {
        <ngxh6-loading-spinner @fadeInOut></ngxh6-loading-spinner>
    }
}
